import { render, staticRenderFns } from "./ContractsChart.vue?vue&type=template&id=644e0793"
import script from "./ContractsChart.vue?vue&type=script&lang=ts"
export * from "./ContractsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports